import * as Prismic from 'prismic-javascript';
import * as PrismicDOM from 'prismic-dom/dist/prismic-dom.js';
var PrismicService = /** @class */ (function () {
    function PrismicService() {
        this._api = Prismic.api("https://greenplease.prismic.io/api/v2", {});
    }
    PrismicService.prototype.api = function () {
        return this._api;
    };
    return PrismicService;
}());
export { PrismicService };
export { Prismic, PrismicDOM };
//# sourceMappingURL=prismic.service.js.map